document.addEventListener('DOMContentLoaded', function () {

  const registerContainer = document.querySelector('.shopify-app-block .customer.register');

  if (registerContainer) {

    const heading = registerContainer.querySelector('h1');
    if (heading) {
      heading.textContent = 'Sign up';

      const subHeading = document.createElement('p');
      subHeading.className = 'sub-heading';
      subHeading.textContent = 'Please fill in the information below:';
      heading.insertAdjacentElement('afterend', subHeading);
    }

    const loginObserver = new MutationObserver(() => {
      const button = registerContainer.querySelector('button');
      if (button && !registerContainer.querySelector('.login-text')) {
        const loginText = document.createElement('p');
        loginText.className = 'login-text';
        loginText.innerHTML =
          'Already have an account? <a href="/account/login">Login</a>';
        button.insertAdjacentElement('afterend', loginText);

        loginObserver.disconnect();
      }
    });

    loginObserver.observe(registerContainer, { childList: true, subtree: true });
  }

});

document.addEventListener('DOMContentLoaded', () => {
  console.log('[INIT] Waiting for #customer-password...');

  const observer = new MutationObserver(() => {
    const passwordInput = document.getElementById('customer-password');

    if (passwordInput) {
      console.log('[FOUND] #customer-password loaded.');

      // Prevent duplicate wrapper
      if (passwordInput.parentNode.classList.contains('password-wrapper')) {
        console.warn('[SKIP] Wrapper already exists.');
        observer.disconnect();
        return;
      }

      // Wrap input
      const wrapper = document.createElement('div');
      wrapper.classList.add('password-wrapper');
      passwordInput.parentNode.insertBefore(wrapper, passwordInput);
      wrapper.appendChild(passwordInput);

      // Create eye icon — default should be SLASH
      const eyeSpan = document.createElement('span');
      eyeSpan.className = 'fa fa-fw fa-eye-slash field-icon toggle-password'; 
      eyeSpan.setAttribute('toggle', '#customer-password');
      wrapper.appendChild(eyeSpan);
      console.log('[ACTION] Added eye-slash icon (default).');

      // Toggle password
      eyeSpan.addEventListener('click', function () {
        const input = document.querySelector(this.getAttribute('toggle'));
        if (!input) {
          console.error('[ERROR] Password input not found for toggling!');
          return;
        }

        const isPassword = input.type === 'password';

        // Toggle visibility
        input.type = isPassword ? 'text' : 'password';

        // Toggle icons (correct direction)
        if (isPassword) {
          // Showing password → use eye
          this.classList.remove('fa-eye-slash');
          this.classList.add('fa-eye');
        } else {
          // Hiding password → use eye-slash
          this.classList.remove('fa-eye');
          this.classList.add('fa-eye-slash');
        }

        console.log('[ACTION] Toggled password, new type:', input.type);
      });

      // Load FontAwesome if needed
      if (!document.querySelector('link[href*="font-awesome"]')) {
        console.log('[ACTION] Loading FontAwesome...');
        const faLink = document.createElement('link');
        faLink.rel = 'stylesheet';
        faLink.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css';
        document.head.appendChild(faLink);
      }

      observer.disconnect();
      console.log('[DONE] password observer disconnected.');
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
